import { Pipe, PipeTransform } from '@angular/core';
import { ItemAttributeValue } from '../../models/item';
import { UserIdToNamePipe } from '../pipes/user-id-to-name.pipe';
import { Observable } from 'rxjs';
import { ConfigService } from '../services/config.service';
import moment from 'moment';
import { filter, map } from 'rxjs/operators';

@Pipe({
  name: 'attributeValueTimestampUser',
  standalone: true
})
export class AttributeValueTimestampUserPipe implements PipeTransform {
  constructor(private userPipe: UserIdToNamePipe) {}

  transform(value: ItemAttributeValue): Observable<string> {
    return this.userPipe.transform(value?.added_by).pipe(
      filter((user) => !!user),
      map(
        (user) =>
          `${moment(value.created_at).format(
            ConfigService.dates.longDateTimeFormat
          )} by ${user}`
      )
    );
  }
}
